import MiddlePanel from 'Components/MiddlePanel/MiddlePanel';
import Panel from 'Components/Panel/Panel';
import { useEffect, useState } from 'react';
import ExecuteAxios from 'Components/ExecuteAxios/ExecuteAxios';
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator';
import PanelListDefault from 'Components/PanelListDefault/PanelListDefault';
import Button from 'Components/Button/Button';
import ReactDatePicker from 'react-datepicker';
import { ptBR } from 'date-fns/locale';
import InputField from 'Components/Input/InputField';

const DeleteConfirmation = ({
    productionDaysIdSelecteds,
    onUpdateShowDeleteConfirmationPanel,
    onUpdateReloadBalanceAllEmployeeHours,
    showDeleteConfirmationPanel,
    onUpdateReloadProductionList
}) => {
    const [loadingDelete, setLoadingDelete] = useState(false)

    async function deleteBalacingDay() {
        try {
            setLoadingDelete(true)
            const response = await ExecuteAxios.api('delete', `/balance-employee/`, {
                params: { productionDayId: productionDaysIdSelecteds[0] }
            });

            if (response) {
                onUpdateReloadProductionList(true)
                onUpdateShowDeleteConfirmationPanel(false)
                onUpdateReloadBalanceAllEmployeeHours(true)
            }
            return response
        } finally {
            setLoadingDelete(false)
        }
    }

    function closeButton() {
        return (
            <Button
                clickMethod={() => {
                    onUpdateShowDeleteConfirmationPanel(false)
                }}
                buttonName={'Fechar'}
                style={closeButtonStyle}
            />
        )
    }

    const closeButtonStyle = {
        width: '85px',
        float: 'right',
        color: 'red',
        fontWeight: '600',
        textAlign: 'center',
        fontSize: '0.8em',
        cursor: 'pointer',
        height: '35px'
    };

    return (
        <MiddlePanel isVisible={showDeleteConfirmationPanel}>
            <LoadingIndicator loaded={!loadingDelete} >
                <Panel
                    deleteFunction={deleteBalacingDay}
                    canDelete={true}
                    enableDelete={true}
                    canViewCRUD={true}
                    componentRightButtons={closeButton()}
                    style={{
                        width: '450px',
                        height: '125px',
                        padding: '5px',
                        borderRadius: '10px',
                        backgroundColor: '#f5f5f5',
                        border: '1px solid #ccc',
                        margin: '10px'
                    }}>
                    <div style={{ margin: '10px', width: '100%' }}>Deseja realmente excluir o balanceamento realizado?</div>
                </Panel>
            </LoadingIndicator>
        </MiddlePanel >
    );
}

export default DeleteConfirmation;
